<template>
  <div>
    <HSuccess />

    <h2 class="text-center mw-300 mx-auto mb-10 green--text">
      {{ $t('quote.hint.paymentSuccess') }}
    </h2>
  </div>
</template>

<script>
import HSuccess from '@/components/app/HSuccess'

export default {
  name: 'QuotePaymentCreditCardSuccess',

  components: {
    HSuccess,
  },

  props: {
    successData: {
      type: Object,
    },
  },
}
</script>
